import { render, staticRenderFns } from "./zyjzg.vue?vue&type=template&id=f9a0d1da&scoped=true"
import script from "./zyjzg.vue?vue&type=script&lang=js"
export * from "./zyjzg.vue?vue&type=script&lang=js"
import style0 from "./zyjzg.vue?vue&type=style&index=0&id=f9a0d1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a0d1da",
  null
  
)

export default component.exports